import { gql } from '@apollo/client';
import '@cobliteam/common-types';
import type { CreateCheckpointManualInput, CreateManualOdometerResponse } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLOdometerRequester {
  public createCheckpointManual = (input: CreateCheckpointManualInput): Promise<CreateManualOdometerResponse> =>
    graphQLRequester
      .mutate<{ createdCheckpoint: CreateManualOdometerResponse }, { input: CreateCheckpointManualInput }>({
        mutation: gql`
          mutation createCheckpointManual($input: CreateCheckpointManualInput!) {
            createCheckpointManual(input: $input) {
              manualOdometer {
                id
                odometerAt
                odometerInKms
                createdBy
                createdAt
              }
              vehicle {
                id
                licensePlate
              }
            }
          }
        `,
        variables: { input },
      })
      .then((result) => result.createdCheckpoint);
}

export default GraphQLOdometerRequester;
